import Text from 'styles/typography';
import { ReactComponent as SVG404 } from 'assets/images/404.svg';
import { Container } from './styles';

export function NotFound() {
  return (
    <Container>
      <header>
        <Text>Você não tem permissão para acessar esse conteúdo!</Text>
      </header>
      <main>
        <SVG404 />
      </main>
    </Container>
  );
}
